/* ============================================================
   TT PROMO ENGINE — tt-promo.js (22/09/2026)
   בן-זוג של snippets/tt-promo-*.liquid ו-assets/tt-promo.css.
   הזכאות והמלל מוכרעים ב-Liquid; הקובץ הזה עושה שלושה דברים בלבד:
   (1) צ'יפ הקוד — לחיצה מעתיקה ללוח + טוסט "הקוד הועתק".
   (2) דף מוצר — "המחיר שלך בקופה" מתעדכן בהחלפת וריאנט.
   (3) עגלה — מציג/מסתיר את התזכורת לפי פריטים זכאים (data-tt-promo על
       הפריט, מ-Liquid) ולפי /cart.js › discount_codes, ומפעיל את הקוד בלחיצה.
   נטען defer רק כשסלוט מופעל (snippets/tt-promo-head.liquid).
   ============================================================ */
(function () {
  'use strict';
  if (window.__ttPromoInit) return;
  window.__ttPromoInit = true;

  /* ---------- helpers ---------- */
  function fmtMoney(cents) {
    try { return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); }
    catch (e) { return '₪' + (cents / 100).toFixed(2); }
  }

  var toastEl = null, toastTimer = null;
  function toast(text) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tt-promo-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = text;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1800);
  }

  function legacyCopy(text) {
    // iOS/ישן, או כש-Clipboard API נדחה (בלי user-activation): textarea זמני + execCommand
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px;';
      document.body.appendChild(ta);
      ta.select();
      try { ta.setSelectionRange(0, text.length); } catch (e) {}
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      if (ok) resolve(); else reject(new Error('copy failed'));
    });
  }
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      // Clipboard API קודם; אם נדחה (למשל בלי user-activation) — נופלים ל-execCommand
      return navigator.clipboard.writeText(text).catch(function () { return legacyCopy(text); });
    }
    return legacyCopy(text);
  }

  function getCart() {
    if (window.theme && theme.cart && theme.cart.getCart) return theme.cart.getCart();
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  /* ---------- (1) צ'יפ הקוד ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-tt-copy]');
    if (!chip) return;
    e.preventDefault();
    e.stopPropagation();
    var code = chip.getAttribute('data-tt-copy') || '';
    if (!code) return;
    copyText(code).then(function () {
      chip.classList.add('is-copied');
      setTimeout(function () { chip.classList.remove('is-copied'); }, 1800);
      toast('הקוד ' + code + ' הועתק ✓');
    }).catch(function () {
      toast('לא הצלחנו להעתיק — הקוד הוא ' + code);
    });
  }, false);

  /* ---------- (2) מחיר סופי בדף המוצר ---------- */
  function computeFinal(cents, type, value) {
    if (type === 'fixed') return Math.max(0, cents - Math.round(value * 100));
    return Math.max(0, Math.round(cents * (100 - value) / 100));
  }
  function updateFinal(scope, variant) {
    if (!variant || typeof variant.price !== 'number') return;
    scope.querySelectorAll('[data-tt-final]').forEach(function (el) {
      var out = el.querySelector('[data-tt-final-price]');
      if (!out) return;
      var type = el.getAttribute('data-type') || 'percent';
      var value = parseFloat(el.getAttribute('data-value')) || 0;
      out.textContent = fmtMoney(computeFinal(variant.price, type, value));
    });
  }
  // theme.js משגר 'variantChange' על מכולת הסקשן (לא מבעבע) — מאזין capture על document
  // עדיין תופס אותו, ו-evt.target תוחם אותנו למוצר הנכון (הדף מול מודאל צפייה מהירה פתוח).
  document.addEventListener('variantChange', function (evt) {
    var v = evt.detail && evt.detail.variant;
    var scope = (evt.target && evt.target.querySelectorAll) ? evt.target : document;
    updateFinal(scope, v);
  }, true);

  /* ---------- (3) תזכורת בעגלה ---------- */
  var nudgeTimer = null;
  function refreshNudges() {
    var nudges = document.querySelectorAll('[data-tt-nudge]');
    if (!nudges.length) return;
    getCart().then(function (cart) {
      var applied = (cart.discount_codes || [])
        .filter(function (d) { return d.applicable; })
        .map(function (d) { return String(d.code).toUpperCase(); });
      nudges.forEach(function (n) {
        var slot = n.getAttribute('data-slot');
        var code = (n.getAttribute('data-code') || '').toUpperCase();
        var form = n.closest('form') || document;
        var eligible = false;
        form.querySelectorAll('[data-products] [data-tt-promo]').forEach(function (it) {
          if (eligible) return;
          var list = (it.getAttribute('data-tt-promo') || '').split(',');
          if (list.indexOf(slot) > -1) eligible = true;
        });
        var show = eligible && (cart.item_count || 0) > 0 && applied.indexOf(code) === -1;
        n.hidden = !show;
      });
    }).catch(function () {});
  }
  function refreshNudgesSoon() {
    clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(refreshNudges, 250);
  }

  function applyNudge(n) {
    if (!n) return;
    var code = n.getAttribute('data-code') || '';
    var btn = n.querySelector('[data-tt-nudge-apply]');
    var msg = n.querySelector('[data-tt-nudge-msg]');
    if (!code || !btn || btn.disabled) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'מפעיל…';
    if (msg) msg.textContent = '';
    getCart().then(function (before) {
      var pre = before.total_discount || 0;
      // GET /discount/CODE רושם את הקוד לסשן (שופיפיי מחילה אותו בעגלה ובקופה) — אותו מנגנון כמו שדה הקופון בעגלה
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () { return getCart(); })
        .then(function (after) {
          var ok = (after.discount_codes || []).some(function (d) {
            return String(d.code).toUpperCase() === code.toUpperCase() && d.applicable;
          }) || (after.total_discount || 0) > pre;
          if (ok) {
            toast('הקוד ' + code + ' הופעל ✓');
            n.hidden = true;
            if (n.closest('#CartPageForm')) {
              window.location.reload();                       // עמוד /cart לא מאזין לבנייה-מחדש
            } else {
              document.dispatchEvent(new CustomEvent('ajaxProduct:added')); // המגירה נבנית מחדש → שורת ההנחה
            }
          } else if (msg) {
            msg.textContent = 'לא ניתן להפעיל את הקוד — ייתכן שכבר יש קופון אחר בעגלה (אין כפל מבצעים).';
          }
        });
    }).catch(function () {
      if (msg) msg.textContent = 'משהו השתבש — נסו שוב, או הזינו את הקוד בקופה.';
    }).then(function () {
      btn.disabled = false;
      btn.textContent = orig;
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tt-nudge-apply]');
    if (!btn) return;
    e.preventDefault();
    applyNudge(btn.closest('[data-tt-nudge]'));
  }, false);

  function bindNudges() {
    if (!document.querySelector('[data-tt-nudge]')) return;
    ['#CartDrawerForm [data-products]', '#CartPageForm [data-products]'].forEach(function (sel) {
      var host = document.querySelector(sel);
      if (host && !host.__ttNudgeObs) {
        host.__ttNudgeObs = true;
        try { new MutationObserver(refreshNudgesSoon).observe(host, { childList: true }); } catch (e) {}
      }
    });
    document.addEventListener('cart:updated', refreshNudgesSoon);
    document.addEventListener('cart:open', refreshNudgesSoon);
    document.addEventListener('ajaxProduct:added', function () { setTimeout(refreshNudges, 700); });
    refreshNudges();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindNudges);
  else bindNudges();
})();
